import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ForecastAreaChart = ({ data, formatINR }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      const dataPoint = payload?.[0]?.payload;
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {dataPoint?.actual && (
            <p className="text-xs text-muted-foreground">Actual: {formatINR(dataPoint?.actual)}</p>
          )}
          <p className="text-xs text-muted-foreground">Forecast: {formatINR(dataPoint?.forecast)}</p>
          <p className="text-xs text-muted-foreground">Range: {formatINR(dataPoint?.lower)} - {formatINR(dataPoint?.upper)}</p>
        </div>
      );
    }
    return null;
  };

  const formatYAxis = (value) => {
    return `₹${(value / 1000000)?.toFixed(0)}M`;
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2">
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-foreground mb-1">Revenue Forecast</h3>
        <p className="text-sm text-muted-foreground">Quarterly projections with confidence intervals</p>
      </div>
      <div className="h-[300px] md:h-[350px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
            <defs>
              <linearGradient id="colorForecast" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8B7EC8" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#8B7EC8" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorActual" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#9AE6B4" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#9AE6B4" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" opacity={0.5} />
            <XAxis
              dataKey="quarter"
              stroke="#64748B"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="#64748B"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: '14px' }}
              iconType="rect"
            />
            <Area
              type="monotone"
              dataKey="upper"
              stroke="none"
              fill="#E9D5FF"
              fillOpacity={0.3}
              name="Upper Bound"
            />
            <Area
              type="monotone"
              dataKey="lower"
              stroke="none"
              fill="#FFFFFF"
              fillOpacity={1}
              name="Lower Bound"
            />
            <Area
              type="monotone"
              dataKey="forecast"
              stroke="#8B7EC8"
              strokeWidth={2}
              fill="url(#colorForecast)"
              name="Forecast"
            />
            <Area
              type="monotone"
              dataKey="actual"
              stroke="#9AE6B4"
              strokeWidth={3}
              fill="url(#colorActual)"
              name="Actual"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ForecastAreaChart;